import { pluralize } from '../index';

export interface ToastMessage {
  type: 'success' | 'warning' | 'error';
  title: string;
  message: string;
}

export interface BulkDeleteResult {
  successCount: number;
  invalidIds: any[];
  failedOperations: Array<{ id: number; error: string }>;
  fileOperationsFailed: boolean;
  warnings: string[];
}

export function createDeleteResultMessages(result: BulkDeleteResult): ToastMessage[] {
  const messages: ToastMessage[] = [];

  if (result.successCount > 0) {
    const count = result.successCount;
    const documentWord = pluralize(count, 'documento', 'documentos');
    const deletedWord = pluralize(count, 'deletado', 'deletados');

    messages.push({
      type: 'success',
      title: 'Sucesso',
      message: `${count} ${documentWord} ${deletedWord} com sucesso.`,
    });
  }

  if (result.invalidIds.length > 0) {
    const count = result.invalidIds.length;
    const idWord = pluralize(count, 'ID', 'IDs');
    const invalidWord = pluralize(count, 'inválido', 'inválidos');
    const foundWord = pluralize(count, 'não encontrado', 'não encontrados');

    messages.push({
      type: 'error',
      title: 'Alguns IDs eram inválidos',
      message: `${count} ${idWord} ${invalidWord} ou ${foundWord}.`,
    });
  }

  if (result.failedOperations.length > 0) {
    const count = result.failedOperations.length;
    const documentWord = pluralize(count, 'documento', 'documentos');
    const verbWord = pluralize(count, 'pôde', 'puderam');
    const deletedWord = pluralize(count, 'deletado', 'deletados');

    messages.push({
      type: 'error',
      title: 'Algumas exclusões falharam',
      message: `${count} ${documentWord} não ${verbWord} ser ${deletedWord}.`,
    });
  }

  if (result.fileOperationsFailed && result.warnings.length > 0) {
    messages.push({
      type: 'warning',
      title: 'Avisos de arquivos',
      message:
        'Alguns arquivos não puderam ser deletados do armazenamento, mas os registros foram removidos.',
    });
  }

  return messages;
}

